<!--
  ~ Copyright (C) 2024 - Potentially Ltd
  ~
  ~ Please see distribution for license.
  -->

<div class="report-section-actions">
  <button mat-icon-button (click)="onSectionDelete()">
    <svg class="svg" role="img" [attr.aria-label]="'translations.global.ariaLabels.icons.style' | transloco">
      <use ogSvgUnify="assets/sprite/sprite.svg#delete"></use>
    </svg>
  </button>

  <button mat-icon-button *ngIf="editIsEnabled" (click)="onSectionEdit()">
    <svg class="svg" role="img" [attr.aria-label]="'translations.global.ariaLabels.icons.edit' | transloco">
      <use ogSvgUnify="assets/sprite/sprite.svg#edit"></use>
    </svg>
  </button>

  <ng-container *ngIf="dragDropIsEnabled">
    <ng-content></ng-content>
  </ng-container>
</div>
